import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { GenericCDataTableDataset } from '../dataset/generic-cdata-table.dataset';
import { IKeyValuePair } from '../../interfaces/IKeyValuePair';
import { ModelConstants } from '../model-constants';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: ModelConstants.genericCDataCopySource,
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(GenericCDataTableDataset)
    }
})
export class GenericCDataCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;

    public additionalFields: Array<IKeyValuePair<string, string | null>> = [];
}
